import { z } from 'zod'

import { TicketPriority } from './AreaPriorities'
import { SlaMetrics } from './SlaMetrics'
import { SummaryDetails } from './SummaryDetails'

export const SubAreaMetrics = z.object({
  priority: TicketPriority,
  areaTime: z.string(),
  responseTime: z.string()
})

export const SubAreaPerformanceMetrics = z.object({
  id: z.string(),
  name: z.string(),
  current: z.string(),
  objective: z.string(),
  priorities: z.array(SubAreaMetrics).nullish(),
  csat: z.number().nullish(),
  star: z.number().nullish()
})

export const SlaAnalysisMetrics = z.object({
  area: SummaryDetails,
  sla: SlaMetrics,
  subAreas: z.array(SubAreaPerformanceMetrics),
  csat: z.number().nullish(),
  star: z.number().nullish()
})

export type SlaAnalysisMetrics = z.infer<typeof SlaAnalysisMetrics>
